import React from 'react';
import { Returns } from '@one-thd/sui-icons';
import { LearnMore } from './LearnMore';

export const LearnMoreReturns = () => {
  return (
    <LearnMore icon={<Returns size="large" color="brand" />} title="Returns In-store or Online" link="/c/Return_Policy">
      <p>Free, Fast & Easy</p>
      <p>100% satisfaction guarantee</p>
    </LearnMore>
  );
};

LearnMoreReturns.displayName = 'LearnMoreReturns';
